import webClient from "../config/api.config";
import { AnalyticsPeriod } from "../types/adminStats.definition";

export function getAdminOverviewStats() {
  return webClient.request({
    method: "get",
    url: "/admin/stats/overview",
  });
}

export function getAdminAnalyticsStats(period: AnalyticsPeriod) {
  return webClient.request({
    method: "get",
    url: "/admin/stats/analytics",
    params: { period },
  });
}
